import React from 'react';

export default function UserProfileImage({ data, picture, username, ...rest }) {
  return (
    <>
      <div className={
          "rounded-full bg-white/20 overflow-hidden flex items-center text-center m-auto mb-4 text-primary-content "
          + (picture && picture.className ? picture.className : " w-12 h-12")
        }
        onClick={()=> { picture && picture.onClick && picture.onClick(); }}
      >
        {data && (data.profile_image ? (
          <img className="w-full h-auto" src={data.profile_image} alt="" />
        ) : (
          <span className="m-auto text-2xl">{data.name}</span>
        ))}
      </div>
      <h1 className={username && username.className ? username.className : " text-primary-content mb-2"}>
        {data && `${data.first_name} ${data.last_name}`}
      </h1>
      <div className="flex justify-center gap-3 mx-auto">
        <div className="badge bg-base-100/20 border-none text-white">{data && data.insurance}</div> 
        <div className="badge bg-base-100/20 border-none text-white">{data && data.insurance_number}</div> 
      </div>
    </>
  );
}

